import { Routes } from '@angular/router';

export const TICKET_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/tickets-index/tickets-index.component').then(
            (x) => x.TicketsIndexComponent,
          ),
      },
      {
        path: ':productUrl/:productId',
        loadComponent: () =>
          import('./pages/tickets-details/tickets-details.component').then(
            (x) => x.TicketsDetailsComponent,
          ),
      },
    ],
  },
];
